'use client';

import React from 'react';
import { Box } from '@skin-seoul/design-system';
import { ProductType, type RecommendedProduct } from '@skin-seoul/service';
import MobileAIChoiceProductCard from './cards/MobileAIChoiceProductCard';
import AIChoiceProductsScrollSkeleton from './AIChoiceProductsScroll.skeleton';
import { useCenterScroll } from '../hooks/useCenterScroll';
import { trackAddToCartAICompare } from '../utils/analytics';
import { extractPathname } from '@skin-seoul/utils';
const scrollableStyle = {
  scrollSnapType: 'x mandatory',
  WebkitOverflowScrolling: 'touch',
  '&::-webkit-scrollbar': {
    display: 'none'
  },
  scrollbarWidth: 'none'
} as const;
interface AIChoiceProductsScrollProps {
  products: RecommendedProduct[] | undefined;
  selectedProductId: number | undefined;
  onProductClick: (productId: number, productLink: string) => void;
}
const AIChoiceProductsScroll = ({
  products,
  selectedProductId,
  onProductClick
}: AIChoiceProductsScrollProps) => {
  const {
    scrollRef,
    registerItemRef
  } = useCenterScroll({
    centerId: selectedProductId,
    items: products || []
  });
  if (!products) {
    return null;
  }
  return <Box ref={scrollRef} display="flex" overflowX="auto" gap={4} css={scrollableStyle} data-sentry-element="Box" data-sentry-component="AIChoiceProductsScroll" data-sentry-source-file="AIChoiceProductsScroll.tsx">
      {products.map((product, index) => {
      const productId = product.parentProductId ?? product.productId;
      return <Box key={product.sku} ref={registerItemRef(productId)} ml={index === 0 ? 'calc(50vw - 120px)' : 0} mr={index === (products.length || 0) - 1 ? 'calc(50vw - 120px)' : 0} minWidth="240px" scrollSnapAlign="center" gap={0} display="flex">
            <MobileAIChoiceProductCard sku={product.sku} href={extractPathname(product.productLink)} name={product.name} brand={product.brand} productImage={product.productImageUrls[0]} currency={product.currency} originalPrice={product.originalPrice} salePrice={product.salePrice} productType={ProductType.Simple} isSelected={selectedProductId === productId} onTrackAddToCart={() => trackAddToCartAICompare(product)} onClick={e => {
          e.preventDefault();
          onProductClick(productId, extractPathname(product.productLink));
        }} />
          </Box>;
    })}
    </Box>;
};
AIChoiceProductsScroll.Skeleton = AIChoiceProductsScrollSkeleton;
export default AIChoiceProductsScroll;